var map = {
	"./activity.png": "8d14",
	"./activity_active.png": "958a",
	"./channel.png": "f121",
	"./channel_active.png": "8a3c",
	"./download.png": "5390",
	"./download_active.png": "57e3",
	"./icon_video_play.png": "6361",
	"./info.png": "59dc",
	"./info_active.png": "50ff",
	"./machine.png": "db01",
	"./machine_active.png": "f52d",
	"./merchant.png": "4026",
	"./merchant_active.png": "c869",
	"./partner.png": "9c5e",
	"./partner_active.png": "dbec",
	"./risk.png": "476e",
	"./risk_active.png": "355f",
	"./serve.png": "bb46",
	"./serve_active.png": "b9d8",
	"./setting.png": "5656",
	"./setting_active.png": "ee16",
	"./settleAccounts.png": "ba93",
	"./settleAccounts_active.png": "4c0a",
	"./statistic.png": "2617",
	"./statistic_active.png": "dc95",
	"./subAccount.png": "2f6a",
	"./subAccount_active.png": "ed81",
	"./transaction.png": "1e2a",
	"./transaction_active.png": "1dd4",
	"./wx.png": "0c8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a233";